"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SchoolDeactivationReasonEnum = void 0;
var SchoolDeactivationReasonEnum;
(function (SchoolDeactivationReasonEnum) {
    SchoolDeactivationReasonEnum["PAYMENT_ISSUE"] = "Payment Issue - Please contact support";
    SchoolDeactivationReasonEnum["CONTRACT_EXPIRATION"] = "Contract Expiration - Please contact support";
    SchoolDeactivationReasonEnum["PRODUCT_MAINTENANCE"] = "Product Maintenance - Service will resume soon";
})(SchoolDeactivationReasonEnum || (exports.SchoolDeactivationReasonEnum = SchoolDeactivationReasonEnum = {}));
